/**************************************************
 * Nombre:       Formulario_Comanda.js
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {FlagOutlined, GroupOutlined, TableRestaurant} from "@mui/icons-material";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {ESTADOSRESERVAS} from "../../Constantes";
import {iniciarChatWass} from "../../Modulo_ChatWass/Funciones/iniciarChatWass";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import IngresoSelectTextoArray from "../../Modulo_formularios/Componentes/IngresoSelectTextoArray";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";

const Formulario_Comanda = ({...props}) => {
    const [mesas, setMesas] = useState([]);


    const chatWhatsApp = (num) => {
        iniciarChatWass({numero: props.props.getValues("celular"), pais: props.props.getValues("pais"), local: false});
    }

    useEffect(() => {
        obtenerCol('mesas').then((mes) => {
            setMesas(mes.data);
        })
    }, []);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'} {...props} dato={'estado'}
                                   opciones={ESTADOSRESERVAS.map((it) => it.nombre)}
                                   editable={false}/>
                </Grid>


                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoTexto Icono={GroupOutlined} nombre={'Num Personas'} {...props} dato={'numPersonas'}
                                  type={'number'}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{px: 1}}>
                    <Typography>Mesa o Mesas</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelectTextoArray {...props} dato={'mesas'} Icono={TableRestaurant}
                                             opciones={mesas.map((it) => it.nombre)}
                                             nombre={'Mesas'}/>
                </Grid>



            </Grid>

        </form>

    )

}
export default Formulario_Comanda